import ExportButtonPopover from './export-button-popover.vue'
ExportButtonPopover.install = function (Vue) {
	Vue.component(ExportButtonPopover.name, ExportButtonPopover);
}
export default ExportButtonPopover